import { isFeatureEnabled } from '../featureToggles.module'

const _getters = {
  canUseSkipSlide: (_, __, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'AHA-39045-skip-slide')
  },
  skipSlides: (state) => {
    return state.skipSlides
  },

  visibleSlides: (_, getters, rootState) => {
    const { presentation } = rootState
    if (!presentation?.slides) return []
    if (!getters.canUseSkipSlide) {
      return presentation.slides
    }
    return presentation.slides.filter((slide) => !getters.skipSlides?.[slide.id])
  },

  visibleQuizSlides: (_, getters) => {
    return (getters.visibleSlides || []).filter((item) => item.type === 'pickAnswer')
  },
}

export default _getters
